/**
 * V2 Page Chrome — wraps existing pages with v2 design tokens
 *
 * Applies: paper background, v2 page bar (eyebrow + title + actions),
 * Inter Tight headings, and consistent spacing.
 * Used to theme existing pages when staff_v2_redesign capability is on
 * without rewriting the entire page.
 *
 * The page bar is the shared PageHeader primitive (components/weavein), so
 * shell-injected chrome and page-authored headers render identically.
 */
import { PageHeader } from '../weavein'

interface V2PageChromeProps {
  /** Breadcrumb/eyebrow text (e.g. "Network") */
  crumb?: string
  /** Page title */
  title: string
  /** Optional right-side actions */
  actions?: React.ReactNode
  /** Page content */
  children: React.ReactNode
  /** Whether to use flush (no padding) layout for the body */
  flush?: boolean
}

export default function V2PageChrome({ crumb, title, actions, children, flush }: V2PageChromeProps) {
  return (
    // h-full + flex-1/min-h-0: fills a fixed-height shell (full-height pages, where
    // the shell's content area is a flex column) and is inert everywhere else.
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden bg-paper">
      <PageHeader eyebrow={crumb || undefined} title={title} actions={actions} />

      {/* Body */}
      <div className={`min-h-0 flex-1 ${flush ? 'overflow-hidden' : 'overflow-y-auto p-4 sm:p-6'}`}>
        {children}
      </div>
    </div>
  )
}
